module.exports = __webpack_public_path__ + "media/images/static/faq/FAQ-8510ce315a2e36ccddd9cc2d789a97e7.png";